(function (global) {
  var HEX = {
    'kinda coral': '#e3927a',
    'sorta seafoam': '#9dbbb3',
    'stormy black': '#2a2a2c',
    'sorta sunny': '#e6c98a',
    'cloudy white': '#e7e3d9',
    charcoal: '#3e3e41',
    chalk: '#e5e1d7',
    sage: '#93a38c',
    lemongrass: '#c4c89a',
    limoncello: '#e2d36a',
    snow: '#f4f2ed',
    obsidian: '#1f1f23',
    hazel: '#b09a78',
    sea: '#2e8ba3',
    coral: '#e07464',
    rose: '#c9a3a8',
    bay: '#5a7e8c',
    porcelain: '#ede5d6',
    aloe: '#8aad8a',
    peony: '#e8a8b8',
    wintergreen: '#6b9b8a',
    'rose quartz': '#d4a8b4',
    iris: '#7b6ba8',
    indigo: '#3d4a8a',
    frost: '#e6eef2',
    moonstone: '#c5cdd4',
    jade: '#6b9b84',
    berry: '#8a3d5a',
    fog: '#c4c8d0',
    lavender: '#c4a8e0'
  };
  HEX.seafoam = HEX['sorta seafoam'];

  var MODELS = {
    'Pixel 6': ['Kinda Coral', 'Sorta Seafoam', 'Stormy Black'],
    'Pixel 6 Pro': ['Sorta Sunny', 'Cloudy White', 'Stormy Black'],
    'Pixel 6a': ['Charcoal', 'Chalk', 'Sage'],
    'Pixel 7': ['Lemongrass', 'Snow', 'Obsidian'],
    'Pixel 7 Pro': ['Hazel', 'Snow', 'Obsidian'],
    'Pixel 7a': ['Charcoal', 'Snow', 'Sea', 'Coral'],
    'Pixel 8': ['Rose', 'Hazel', 'Obsidian'],
    'Pixel 8 Pro': ['Bay', 'Porcelain', 'Obsidian'],
    'Pixel 8a': ['Bay', 'Aloe', 'Porcelain', 'Obsidian'],
    'Pixel 9': ['Peony', 'Wintergreen', 'Porcelain', 'Obsidian'],
    'Pixel 9 Pro': ['Rose Quartz', 'Hazel', 'Porcelain', 'Obsidian'],
    'Pixel 9 Pro XL': ['Rose Quartz', 'Hazel', 'Porcelain', 'Obsidian'],
    'Pixel 9a': ['Peony', 'Iris', 'Porcelain', 'Obsidian'],
    'Pixel 10': ['Indigo', 'Frost', 'Lemongrass', 'Obsidian'],
    'Pixel 10 Pro': ['Moonstone', 'Jade', 'Porcelain', 'Obsidian'],
    'Pixel 10 Pro XL': ['Moonstone', 'Jade', 'Porcelain', 'Obsidian'],
    'Pixel 10a': ['Berry', 'Fog', 'Lavender', 'Obsidian']
  };

  var ORDERED_KEYS = [
    'kinda coral',
    'sorta seafoam',
    'sorta sunny',
    'cloudy white',
    'stormy black',
    'rose quartz',
    'wintergreen',
    'lemongrass',
    'limoncello',
    'moonstone',
    'porcelain',
    'obsidian',
    'charcoal',
    'lavender',
    'seafoam',
    'coral',
    'peony',
    'iris',
    'hazel',
    'aloe',
    'chalk',
    'sage',
    'indigo',
    'frost',
    'jade',
    'berry',
    'fog',
    'snow',
    'rose',
    'bay',
    'sea'
  ];

  function normalize(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hexFor(name) {
    var key = normalize(name);
    if (HEX[key]) return HEX[key];
    var i;
    for (i = 0; i < ORDERED_KEYS.length; i += 1) {
      if (key.indexOf(ORDERED_KEYS[i]) !== -1) {
        return HEX[ORDERED_KEYS[i]];
      }
    }
    return '';
  }

  function colorsForModel(model) {
    return MODELS[model] || [];
  }

  global.GhostPixelColors = {
    HEX: HEX,
    MODELS: MODELS,
    hexFor: hexFor,
    colorsForModel: colorsForModel
  };
})(typeof window !== 'undefined' ? window : this);
